export default __webpack_public_path__ + "static/media/typehelicopter.5c12dcb4.svg";